// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { EducationalTooltip } from '@/components/educational-tooltip';
import { InfoOutlined } from '@/constants/hardfin-standard-icons';
import { useDisclosure } from '@/hooks/use-disclosure';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import { useRef } from 'react';

interface Props {
  title: string;
}

export function FulfillmentReportEducationalTitle(props: Props) {
  const infoTooltip = useDisclosure();
  const infoButtonRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography variant="h5">{props.title}</Typography>
        <IconButton
          ref={infoButtonRef}
          size="small"
          onClick={infoTooltip.open}
          aria-label={`Learn about the ${props.title}`}
        >
          <InfoOutlined fontSize="small" />
        </IconButton>
      </Stack>
      <EducationalTooltip
        title={props.title}
        isOpen={infoTooltip.isOpen}
        onClose={infoTooltip.close}
        anchorElement={infoButtonRef.current}
        placement="bottom-start"
      >
        <Stack spacing={2}>
          <Typography variant="body2">
            Shows project demand, fulfillment-order requests, and shipment
            coverage by SKU across the organization. Use it to find remaining
            need, overages, and partially covered demand before drilling into a
            project fulfillment tab.
          </Typography>
          <Box>
            <Typography variant="subtitle2" gutterBottom>
              How need is calculated
            </Typography>
            <Typography variant="body2">
              Need is project requested quantity minus pending, shipped, and
              delivered quantities. When coverage is greater than project
              demand, the overage is shown in parentheses.
            </Typography>
          </Box>
        </Stack>
      </EducationalTooltip>
    </>
  );
}
